const keyContainsModifier = (e) => {
    return e.ctrlKey || e.altKey || e.shiftKey || e.metaKey;
}

export default keyContainsModifier;